<template>
  <VView class="home">
    <VText center>
      <big>
        <span>ODKRYJ <u>na nowo</u><br />
        pojazdy dickie toys!</span>
      </big>
    </VText>

    <VText center>
      <span>Wygraj</span><br />
      <small>NIEZAPOMNIANY lot<br />
      w tunelu aerodynamicznym<br />
      <span>lub</span> pojazdy Dickie VOLVO!</small>
    </VText>

    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton to="/menu" special>Zaczynajmy!</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';
import VMedia from '@/components/VMedia.vue';
import VText from '@/components/VText.vue';

export default {
  name: 'Home',
  components: {
    VView,
    VButton,
    VButtonGroup,
    VMedia,
    VText,
  },
};
</script>

<style lang="scss" scoped>
.home {}
</style>
